/**
 * CCUK universal page-back navigation.
 *
 * Genuine page Back buttons should return to the previous browser/PWA
 * history entry. A supplied fallback is used only when this tab does not
 * contain a usable previous application entry.
 *
 * Do NOT use this for:
 * - pagination
 * - carousels
 * - previous month
 * - wizard/registration previous steps
 * - modal/drawer close controls
 * - internal admin sub-views
 */
export function canNavigateBack() {
  if (typeof window === 'undefined') return false;

  const idx = window.history?.state?.idx;

  // React Router maintains an index for SPA history entries.
  if (typeof idx === 'number') {
    return idx > 0;
  }

  // Compatibility fallback for browser/PWA sessions where idx is absent.
  return window.history.length > 1;
}

export function goBackOrFallback(navigate, fallback = '/') {
  if (typeof navigate !== 'function') return;

  if (canNavigateBack()) {
    navigate(-1);
    return;
  }

  navigate(fallback, { replace: true });
}
